import React from 'react'
import Skeleton from '../UI/Skeleton'
class TestEmulation extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className='card lesson-card'>
                    <Skeleton count={2} className="md-font-size" />
                    <div className='question-wrapper'>
                        <div className='checkboxes'>
                            <div className='mt-2'>
                                <Skeleton circle={true} width={16} height={16} className="mr-2 mb-1" />
                                <Skeleton className="md-font-size" width={'50%'} />
                            </div>
                            <div className='mt-2'>
                                <Skeleton circle={true} width={16} height={16} className="mr-2 mb-1" />
                                <Skeleton className="md-font-size" width={'50%'} />
                            </div>
                            <div className='mt-2'>
                                <Skeleton circle={true} width={16} height={16} className="mr-2 mb-1" />
                                <Skeleton className="md-font-size" width={'50%'} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card lesson-card'>
                    <Skeleton count={2} className="md-font-size" />
                    <div className='question-wrapper'>
                        <div className='checkboxes'>
                            <div className='mt-2'>
                                <Skeleton circle={true} width={16} height={16} className="mr-2 mb-1" />
                                <Skeleton className="md-font-size" width={'50%'} />
                            </div>
                            <div className='mt-2'>
                                <Skeleton circle={true} width={16} height={16} className="mr-2 mb-1" />
                                <Skeleton className="md-font-size" width={'50%'} />
                            </div>
                            <div className='mt-2'>
                                <Skeleton circle={true} width={16} height={16} className="mr-2 mb-1" />
                                <Skeleton className="md-font-size" width={'50%'} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="lesson-btn-wrapper d-flex justify-content-between flex-wrap w-100">
                    <Skeleton height={40} width={250} />
                    <Skeleton height={40} width={250} />
                    <Skeleton height={40} width={250} />
                </div>
            </React.Fragment>
        )
    }
}

export default TestEmulation



// WEBPACK FOOTER //
// ./src/components/Study/TestEmulation.jsx